<template>
        <div class="container">
        <el-footer style="height: 90px;">
			<div class="footwrapper1">
				<span class="foot-item">{{$t('m.t.banquan')}}</span>
				<span class="foot-item">|</span>
				<span class="foot-item"><a href="https://beian.miit.gov.cn/">{{$t('m.t.icp')}}</a></span>
			</div>
			
			<div class="footwrapper3">
				<span class="foot-item1">{{$t('m.t.banquan')}}</span>
				<span class="foot-item2"><a href="https://beian.miit.gov.cn/">{{$t('m.t.icp')}}</a></span>
			</div>
			
			
			
			<div class="footwrapper2">
				<span class="foot-item2">
					<a href="https://map.baidu.com/search/%E4%B8%8A%E6%B5%B7%E5%B8%82%E6%9D%BE%E6%B1%9F%E5%8C%BA%E4%B9%9D%E4%BA%AD%E9%95%87%E4%B9%9D%E6%B3%BE%E8%B7%AF959%E5%8F%B7%E6%88%96%E6%B4%8B%E6%B2%B3%E6%B5%9C%E8%B7%AF501%E5%8F%B71%E5%B9%A2227%E5%AE%A4/@13502519.125,3629823,19z?querytype=s&da_src=shareurl&wd=%E4%B8%8A%E6%B5%B7%E5%B8%82%E6%9D%BE%E6%B1%9F%E5%8C%BA%E4%B9%9D%E4%BA%AD%E9%95%87%E4%B9%9D%E6%B3%BE%E8%B7%AF959%E5%8F%B7%E6%88%96%E6%B4%8B%E6%B2%B3%E6%B5%9C%E8%B7%AF501%E5%8F%B71%E5%B9%A2227%E5%AE%A4&c=289&src=0&pn=0&sug=0&l=13&b=(13476995,3622353;13526147,3646257)&from=webmap&biz_forward=%7B%22scaler%22:2,%22styles%22:%22pl%22%7D&device_ratio=2" target="_blank">{{$t('m.t.company')}}:{{$t('m.t.companyname')}}</a>
					</span>
				<span class="foot-item2">|</span>
				<span class="foot-item2">
					<a href="https://map.baidu.com/search/%E4%B8%8A%E6%B5%B7%E5%B8%82%E6%9D%BE%E6%B1%9F%E5%8C%BA%E4%B9%9D%E4%BA%AD%E9%95%87%E4%B9%9D%E6%B3%BE%E8%B7%AF959%E5%8F%B7%E6%88%96%E6%B4%8B%E6%B2%B3%E6%B5%9C%E8%B7%AF501%E5%8F%B71%E5%B9%A2227%E5%AE%A4/@13502519.125,3629823,19z?querytype=s&da_src=shareurl&wd=%E4%B8%8A%E6%B5%B7%E5%B8%82%E6%9D%BE%E6%B1%9F%E5%8C%BA%E4%B9%9D%E4%BA%AD%E9%95%87%E4%B9%9D%E6%B3%BE%E8%B7%AF959%E5%8F%B7%E6%88%96%E6%B4%8B%E6%B2%B3%E6%B5%9C%E8%B7%AF501%E5%8F%B71%E5%B9%A2227%E5%AE%A4&c=289&src=0&pn=0&sug=0&l=13&b=(13476995,3622353;13526147,3646257)&from=webmap&biz_forward=%7B%22scaler%22:2,%22styles%22:%22pl%22%7D&device_ratio=2" target="_blank">
					{{$t('m.t.address')}}:{{$t('m.t.addressname')}}
					</a>
					</span>
				<span class="foot-item2">|</span>
				<span class="foot-item2">
					<a  target="_blank">
					{{$t('m.t.phone')}}:{{'021-60198889'}}
					</a>
					</span>
				
				<span class="foot-item2">|</span>
				<span class="foot-item2">{{$t('m.t.Online')}}:www.zx-cargo.com</span>
				
			</div>
			
		</el-footer>

  		</div>
</template>
<script>
export default {
  name: "nav-footer",
};
</script>

<style lang="scss" scoped>
 .container{
   // width: 100%;
	 background-color:#00092B ;
	 color: white;
 }
 
 @media screen and (min-width: 1280px) {
	.footwrapper1{
		 display: flex;
		 justify-content: center;
		 .foot-item{
			 padding:15px 10px 0 0px;
			 font-size:13px
		 }
	}
	.footwrapper2{
		 display: flex;
		 justify-content: center;
		 .foot-item2{
		 		 padding:10px 10px 0 0px;
		 		 font-size:13px
		 }
	} 
	.footwrapper3{
		display: none;
	}
 }
 @media screen and (max-width: 1280px) {
	.footwrapper3{
		display: flex;
		flex-direction: column;
		text-align: center;
		.foot-item1{
			padding: 15px 0 0 0;
		}
		.foot-item2{
			padding: 10px 0;
		}
	}
	.footwrapper1{
		display: none;
	}
	.footwrapper2{
		display: none;
	} 
 }
</style>
